import gsap, {Linear} from 'gsap';

export default function makerCog(el) {

    //Setup
    const innerCog = el.getElementsByClassName('Makerlab_Cog__inner-cog')[0];
    const middleCog = el.getElementsByClassName('Makerlab_Cog__middle-cog')[0];
    const outerCog = el.getElementsByClassName('Makerlab_Cog__outer-cog')[0];





    gsap.set([innerCog, middleCog, outerCog], { transformOrigin : `50% 50%`});


    const rotation = '+=360';

    // Inner Cog
    gsap.to(innerCog, {rotate : rotation, duration: 5, ease: 'none', repeat :-1});


    // Middle Cog
    const md = gsap.timeline({ repeat : -1});
    const midEase = "elastic.out(0.9, 0.8)";
    const midDuration = 40;

    md.to(middleCog, {rotate :'+=360', duration: midDuration, ease: 'none'})



    //Outer Cog
    gsap.to(outerCog, {rotation :rotation, duration: 20, ease: Linear.easeNone, repeat :-1});





}

document.onreadystatechange = () => {
    const  el = document.getElementById('Makerlab_Cog');

    if(el) {
        makerCog(el);
    }
}

